import { _ as n } from "../internals/export.js";
import { f as o } from "../internals/function-bind.js";
n({
  target: "Function",
  proto: !0,
  forced: Function.bind !== o
}, {
  bind: o
});